module.exports = __webpack_public_path__ + "static/media/ftx.83846576.svg";